import { render } from "./card_edit.vue?vue&type=template&id=50c2f9b5&scoped=true"
import script from "./card_edit.vue?vue&type=script&lang=js"
export * from "./card_edit.vue?vue&type=script&lang=js"

import "./card_edit.vue?vue&type=style&index=0&id=50c2f9b5&lang=less&scoped=true"

import exportComponent from "E:\\work\\高大\\pps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50c2f9b5"]])

export default __exports__